module.exports = __webpack_public_path__ + "static/img/buy_zhuangbei_active.65452352.png";